import { ReactNode } from 'react'

import Loading from '@atoms/Loading'

import * as style from './style.module.sass'

type ButtonProps = {
  children: ReactNode
  onClick?: () => void
  design?: 'black' | 'dark' | 'white'
  type?: 'button' | 'submit'
  disabled?: boolean
  loading?: boolean
  hover?: 'default' | 'opacity'
}
const Button = ({
  children,
  onClick,
  design = 'black',
  type = 'button',
  disabled = false,
  loading = false,
  hover = 'default',
}: ButtonProps) => (
  <button
    onClick={onClick}
    type={type}
    className={style.button}
    data-design={design}
    data-hover={hover}
    disabled={disabled || loading}
  >
    {loading ? (
      <Loading design={design === 'white' ? 'black' : 'white'} size="small" />
    ) : (
      children
    )}
  </button>
)

export default Button
